module.exports = __webpack_public_path__ + "static/media/preparetoshare.1baab442.png";